module.exports = __webpack_public_path__ + "img/pizza-6.57763bb5.jpg";